import { Component, HostBinding, Input } from '@angular/core';
import { ProgressbarConfig } from './progressbar.config';
import { isBs3 } from '../utils/index';
import { BarComponent } from './bar.component';


export class ProgressbarComponent {
  /** if `true` changing value of progress bar will be animated*/
   animate: boolean;
  /** If `true`, striped classes are applied */
   striped: boolean;
  /** provide one of the four supported contextual classes: `success`, `info`, `warning`, `danger` */
   type: string;
  /** current value of progress bar. Could be a number or array of objects
   * like {"value":15,"type":"info","label":"15 %"}
   */
  
  set value(value: number | any[]) {
    this.isStacked = Array.isArray(value);
    this._value = value;
  }
  isStacked = false;
  _value: number | any[];
  get isBs3(): boolean {
    return isBs3();
  }

  /** maximum total value of progress element */
  
  
  get max(): number {
    return this._max;
  }

  set max(v: number) {
    this._max = v;
    this.bars.forEach((bar: BarComponent) => {
      bar.recalculatePercentage();
    });
  }

   addClass = true;

  bars: any[] = [];

  protected _max = 100;

  constructor(config: ProgressbarConfig) {
    Object.assign(this, config);
  }
  addBar(bar: BarComponent): void {
    bar.animate = this.animate;
    bar.striped = this.striped;

    this.bars.push(bar);
  }

  removeBar(bar: BarComponent): void {
    this.bars.splice(this.bars.indexOf(bar), 1);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'progressbar',
  template: "<bar [type]=\"type\" [value]=\"_value\" *ngIf=\"!isStacked\"> <ng-content></ng-content> </bar> <ng-template [ngIf]=\"isStacked\"> <bar *ngFor=\"let item of _value\" [type]=\"item.type\" [value]=\"item.value\">{{ item.label }}</bar> </ng-template> ",
  styles: [
    `
    :host {
      width: 100%;
      display: flex;
    }
  `
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ProgressbarConfig, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'animate': [{ type: Input },],
'striped': [{ type: Input },],
'type': [{ type: Input },],
'value': [{ type: Input },],
'max': [{ type: HostBinding, args: ['attr.max', ] },{ type: Input },],
'addClass': [{ type: HostBinding, args: ['class.progress', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
